export const Request = {
  BirData: "getMeABirData",
  ConfirmRegistration: "confirmRegistration",
  CreateAndSaveInvoice: "casPInvoice",
  CreateAccount: "createAccount",
  DownloadKey: "downloadkey",
  DownloadSoftware: "downloadexe",
  GetDeviceData: "getDeviceData",
  GetHelpDesk: "getHelpDesk",
  GetLastEditionData: "getLastEditionData",
  GetMonthlySubscriptionData: "getMonthlySubscriptionData",
  GetUser: "getUser",
  IsIUser: "isIUser",
  GetVatPercentage: "getVatPercentage",
  Login: "login",
  LoginByUUID: "loginByUUID",
  Logout: "logout",
  Order: "order",
  RentalSubscriptionPayment: "rentalSubscriptionPayment",
  SendRegistrationConfirmLink: "sendRegConfirmLink",
  SendInvoiceOnMail: "sendInvoiceOnMail",
  ResetUserPassword: "resetPass",
  UpdateUserData: "updateUsrData",
  UpdateUserPassword: "updateUsrPass",
  getUserOrderHistory: "getUserOrderHistory",
  downloadFile: "getPInvoiceFile",
};
